import { render, staticRenderFns } from "./PlcSet.vue?vue&type=template&id=39b2d7a0&scoped=true"
import script from "./PlcSet.vue?vue&type=script&lang=js"
export * from "./PlcSet.vue?vue&type=script&lang=js"
import style0 from "./PlcSet.vue?vue&type=style&index=0&id=39b2d7a0&prod&scoped=true&lang=css"
import style1 from "./PlcSet.vue?vue&type=style&index=1&id=39b2d7a0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b2d7a0",
  null
  
)

export default component.exports